import { Injectable } from '@angular/core';
import { Auth, signOut, user, User } from '@angular/fire/auth';
import * as Sentry from '@sentry/angular';
import { AppUser, IAppUser } from '../models/app-user.model';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse, serverResponseFromError } from '../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public loggedIn: boolean = false;

  public currentFirebaseUser?: User;

  public currentUser?: AppUser;

  /* message que regresó la API en el último recoverPassword. */
  public recoverMessage: string = '';
  public subCurrentUser: Subject<AppUser> = new Subject<AppUser>();

  constructor(
    public auth: Auth,
    private http: HttpClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private router: Router
  ) {
    user(this.auth).subscribe((_user) => {
      if (_user) {
        console.log('Existe usuario');
        
        this.loggedIn = true;
        this.currentFirebaseUser = _user;
        Sentry.setUser({
          id: _user.uid,
          email: _user.email ?? undefined
        });
        this.getUser();
      } else {
        console.log('NO Existe usuario');
        this.loggedIn = false;
        Sentry.setUser(null);
      }
    });
  }

  /*
   ██████╗ ███████╗████████╗███████╗██╗██████╗ ███████╗██████╗  █████╗ ███████╗███████╗██╗   ██╗███████╗███████╗██████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔════╝██║██╔══██╗██╔════╝██╔══██╗██╔══██╗██╔════╝██╔════╝██║   ██║██╔════╝██╔════╝██╔══██╗
  ██║  ███╗█████╗     ██║   █████╗  ██║██████╔╝█████╗  ██████╔╝███████║███████╗█████╗  ██║   ██║███████╗█████╗  ██████╔╝
  ██║   ██║██╔══╝     ██║   ██╔══╝  ██║██╔══██╗██╔══╝  ██╔══██╗██╔══██║╚════██║██╔══╝  ██║   ██║╚════██║██╔══╝  ██╔══██╗
  ╚██████╔╝███████╗   ██║   ██║     ██║██║  ██║███████╗██████╔╝██║  ██║███████║███████╗╚██████╔╝███████║███████╗██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝     ╚═╝╚═╝  ╚═╝╚══════╝╚═════╝ ╚═╝  ╚═╝╚══════╝╚══════╝ ╚═════╝ ╚══════╝╚══════╝╚═╝  ╚═╝

  */
 /**
  * FUNCTION getFirebaseUser
  * 
  * @returns 
  */
  async getFirebaseUser(): Promise<User | null> {
    return new Promise((resolve, reject) => {
      
      if(this.currentFirebaseUser) {
        resolve(this.currentFirebaseUser);
      } else {
        user(this.auth).subscribe((_user) => {
          if (_user) {
            console.log('Existe usuario');
            
            this.loggedIn = true;
            this.currentFirebaseUser = _user;
            this.getUser();
            resolve(_user);
          } else {
            console.log('NO Existe usuario');
            this.loggedIn = false;
            resolve(null);
          }
        });
      }

    });
    
  }

  /*
   ██████╗ ███████╗████████╗████████╗ ██████╗ ██╗  ██╗███████╗███╗   ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔═══██╗██║ ██╔╝██╔════╝████╗  ██║
  ██║  ███╗█████╗     ██║      ██║   ██║   ██║█████╔╝ █████╗  ██╔██╗ ██║
  ██║   ██║██╔══╝     ██║      ██║   ██║   ██║██╔═██╗ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝███████╗   ██║      ██║   ╚██████╔╝██║  ██╗███████╗██║ ╚████║
   ╚═════╝ ╚══════╝   ╚═╝      ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═══╝

  */
 /**
  * FUNCTION getToken
  * 
  * @returns 
  */
  async getToken(): Promise<String> {
    const user = await this.getFirebaseUser();

    const token = await user?.getIdToken();
    
    return token ?? '';
  }

  /*
   ██████╗ ███████╗████████╗██╗   ██╗███████╗███████╗██████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██║   ██║██╔════╝██╔════╝██╔══██╗
  ██║  ███╗█████╗     ██║   ██║   ██║███████╗█████╗  ██████╔╝
  ██║   ██║██╔══╝     ██║   ██║   ██║╚════██║██╔══╝  ██╔══██╗
  ╚██████╔╝███████╗   ██║   ╚██████╔╝███████║███████╗██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝    ╚═════╝ ╚══════╝╚══════╝╚═╝  ╚═╝

  */
 /**
  * FUNCTION getUser
  */
  async getUser() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando datos de usuario';

    const token = await this.currentFirebaseUser?.getIdToken();
    // console.log('token: ', token);
    
    const urlApi = `${environment.urlApi}/account`;

    try {

      const response = await new Promise<ServerResponse<{ user: IAppUser }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ user: IAppUser }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token ?? ''
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ user: IAppUser }>
              ) => resolve(
                new ServerResponse<{ user: IAppUser }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        this.currentUser = new AppUser(
          response.data?.user!
        );

        this.subCurrentUser.next(this.currentUser);
        Sentry.setUser({
          id: this.currentUser.uid,
          email: this.currentUser.email,
          username: this.currentUser.fullName
        });
      }

      console.log(
        this.currentUser,
      );
      

    } catch(error) {
      console.log(error);
    }


    this.spinnerService.loading = false;
    this.spinnerService.message = '';
  }

  /*
  ███████╗██╗ ██████╗ ███╗   ██╗ ██████╗ ██╗   ██╗████████╗
  ██╔════╝██║██╔════╝ ████╗  ██║██╔═══██╗██║   ██║╚══██╔══╝
  ███████╗██║██║  ███╗██╔██╗ ██║██║   ██║██║   ██║   ██║
  ╚════██║██║██║   ██║██║╚██╗██║██║   ██║██║   ██║   ██║
  ███████║██║╚██████╔╝██║ ╚████║╚██████╔╝╚██████╔╝   ██║
  ╚══════╝╚═╝ ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝    ╚═╝

  */
 /**
  * FUNCTION signOut
  */
  async signOut() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cerrando sesión';

    await signOut(this.auth);
    Sentry.setUser(null);

    this.currentUser = undefined;

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    sessionStorage.removeItem('user');
    this.loggedIn = false;
    this.router.navigate(['login']);
  }

  // region recoverPassword
  /* source indica a qué app lleva el enlace del correo: 'console' (este panel)
     o 'clients-app' (usuarios con profile "user"). Con silent no se usa el
     spinner global: la pantalla que lo pide pinta su propio estado de carga.
     El message de la API (éxito o error) queda en recoverMessage. */
  async recoverPassword(
    email: string,
    source: 'console' | 'clients-app' = 'console',
    options?: { silent?: boolean }
  ): Promise<boolean> {

    let flag = false;

    const silent = options?.silent ?? false;

    const urlApi = `${environment.urlApi}/auth/recover-password`;

    this.recoverMessage = '';

    if (!silent) {
      this.spinnerService.loading = true;
      this.spinnerService.message = 'Enviando correo';
    }

    try {

      const response = await new Promise<ServerResponse>(
        (resolve) => {
          this.http.post<IServerResponse>(
            urlApi,
            JSON.stringify({ email: email, source: source }),
            {
              headers: {
                "content-type": "application/json"
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse
              ) => resolve(
                new ServerResponse(response)
              ),
            // Sin sobre de la API (500, CORS, red) resuelve con un mensaje en español
            error: (error) => resolve(serverResponseFromError(error)),
          });
        }
      );

      console.log(response);

      this.recoverMessage = response.message;

      if(response.statusCode === 200) {
        flag = true;
      } else {
        this.toastService.show(
          {
            header: 'No se pudo enviar',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );
      }

    } catch(error) {
      console.log(error);
    }

    if (!silent) {
      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return flag;

  }

}
